import { instanceCMSAssetAPI } from "../../../../api";
import { baseURL } from "../../../../config/axios";

export const getDirectionImage = (
  dir,
  type = false,
  isAffectingAllStation = false
) => {
  switch (dir) {
    case "both":
      return "both-ways-direction.png";

    case "asc":
      return "one-way-left-direction.png";

    case "desc":
      return "one-way-right-direction.png";

    case "sector":
      return "sector-down.png";

    default:
      break;
  }
};

export const getDisruptionAssetSrc = (filename) => {
  const ASSET_URL = baseURL + instanceCMSAssetAPI + "/";
  return ASSET_URL + filename + "/file";
};
